import React, { useState, useEffect } from 'react';
import MapaInteractivo from '../components/MapaInteractivo';

const Contact = () => {
  // ==========================================
  // CONSTANTES DE SEGURIDAD
  // ==========================================
  const API_SECRET_TOKEN = 'SV0e2b4B3mij0NDLMdkwa1EHXYak/zOudvdfdAqbweQ='; // Mismo que en PHP
  const RECAPTCHA_SITE_KEY = '6Le35CMsAAAAAE2MxAw06wqj6ta82v6rYfxwADoF'; // SITE KEY real de Google reCAPTCHA v3

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: '',
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitMessage, setSubmitMessage] = useState(null);
  const [submitType, setSubmitType] = useState(null); // 'success' o 'error'
  const [recaptchaLoaded, setRecaptchaLoaded] = useState(false);

  // ==========================================
  // CARGAR reCAPTCHA v3
  // ==========================================
  useEffect(() => {
    // Verificar si ya está cargado
    if (window.grecaptcha) {
      setRecaptchaLoaded(true);
      return;
    }

    // Cargar script de reCAPTCHA v3
    const script = document.createElement('script');
    script.src = `https://www.google.com/recaptcha/api.js?render=${RECAPTCHA_SITE_KEY}`;
    script.async = true;
    script.defer = true;

    script.onload = () => {
      setRecaptchaLoaded(true);
    };

    script.onerror = () => {
      console.error('Error al cargar reCAPTCHA');
      setRecaptchaLoaded(false);
    };

    document.head.appendChild(script);

    // Cleanup
    return () => {
      // No remover el script para evitar recarga innecesaria
    };
  }, [RECAPTCHA_SITE_KEY]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleEmailSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitMessage(null);

    try {
      // ==========================================
      // 1. OBTENER TOKEN DE reCAPTCHA v3
      // ==========================================
      if (!recaptchaLoaded || !window.grecaptcha) {
        throw new Error('reCAPTCHA no está disponible');
      }

      const recaptchaToken = await window.grecaptcha.execute(RECAPTCHA_SITE_KEY, {
        action: 'contact',
      });

      // ==========================================
      // 2. CREAR FORMDATA CON DATOS + TOKEN + API SECRET
      // ==========================================
      const formDataToSend = new FormData();
      formDataToSend.append('name', formData.name);
      formDataToSend.append('email', formData.email);
      formDataToSend.append('phone', formData.phone);
      formDataToSend.append('message', formData.message);
      formDataToSend.append('recaptcha_token', recaptchaToken); // reCAPTCHA token
      formDataToSend.append('api_token', API_SECRET_TOKEN); // API Secret Token

      // ==========================================
      // 3. ENVIAR AL SERVIDOR PHP
      // ==========================================
      const response = await fetch('/sendMail.php', {
        method: 'POST',
        body: formDataToSend,
      });

      const data = await response.json();

      // ==========================================
      // 4. MANEJAR RESPUESTA
      // ==========================================
      if (data.success) {
        // Éxito
        setSubmitType('success');
        setSubmitMessage(
          '¡Gracias por contactarnos! Tu mensaje ha sido enviado correctamente. Nos pondremos en contacto contigo pronto.'
        );

        // Limpiar formulario
        setFormData({
          name: '',
          email: '',
          phone: '',
          message: '',
        });

        // Ocultar mensaje después de 10 segundos
        setTimeout(() => {
          setSubmitMessage(null);
        }, 10000);
      } else {
        // Error del servidor (respuesta genérica)
        setSubmitType('error');
        setSubmitMessage(
          'Hubo un error al enviar el mensaje. Por favor intenta de nuevo o contáctanos directamente por WhatsApp.'
        );

        // Ocultar mensaje después de 10 segundos
        setTimeout(() => {
          setSubmitMessage(null);
        }, 10000);
      }
    } catch (error) {
      // Error de red o fetch
      setSubmitType('error');
      setSubmitMessage(
        'Error de conexión. Por favor verifica tu conexión a internet e intenta de nuevo.'
      );

      // Ocultar mensaje después de 10 segundos
      setTimeout(() => {
        setSubmitMessage(null);
      }, 10000);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleWhatsAppClick = () => {
    const message = formData.name
      ? encodeURIComponent(`Hola, soy ${formData.name}. Quiero información sobre TecnoVigilancia 360`)
      : encodeURIComponent('Hola, quiero información sobre TecnoVigilancia 360');

    window.open(`https://wa.me/525533326766?text=${message}`, '_blank');
  };

  return (
    <div className="page">
      <section className="page-header">
        <div className="container">
          <h1 className="page-title">Contáctanos</h1>
          <p className="page-subtitle">Estamos listos para atenderte y resolver todas tus dudas</p>
        </div>
      </section>

      <section className="contact-section">
        <div className="container">
          <div className="contact-grid">
            {/* Información de contacto */}
            <div className="contact-info">
              <h2 className="section-title">Información de Contacto</h2>

              <div className="info-card">
                <div className="info-icon">📍</div>
                <div className="info-content">
                  <h3>Dirección</h3>
                  <p>C. Felipe Vinicio V. Berriozábal</p>
                  <p>Mza 17 Lt 33</p>
                  <p>Coacalco, Estado de México</p>
                </div>
              </div>

              <div className="info-card">
                <div className="info-icon">📞</div>
                <div className="info-content">
                  <h3>Teléfono</h3>
                  <p>
                    <a href="tel:+525533326766" className="contact-link">
                      55 3332 6766
                    </a>
                  </p>
                </div>
              </div>

              <div className="info-card">
                <div className="info-icon">✉️</div>
                <div className="info-content">
                  <h3>Correo Electrónico</h3>
                  <p>
                    <a href="mailto:ventas@tecnovigilancia360.com" className="contact-link">
                      ventas@tecnovigilancia360.com
                    </a>
                  </p>
                </div>
              </div>

              <div className="info-card">
                <div className="info-icon">🕒</div>
                <div className="info-content">
                  <h3>Horario de Atención</h3>
                  <p>
                    <strong>Lunes a Sábado:</strong> 9:00 AM - 6:00 PM
                  </p>
                  <p>
                    <strong>Domingo:</strong> Cerrado
                  </p>
                </div>
              </div>

              {/* Botón directo de WhatsApp */}
              <button className="btn btn-whatsapp-contact" onClick={handleWhatsAppClick}>
                💬 Escribir por WhatsApp
              </button>
            </div>

            {/* Formulario de contacto */}
            <div className="contact-form-container">
              <h2 className="section-title">Envíanos un Mensaje</h2>

              {/* Mensaje de éxito o error */}
              {submitMessage && (
                <div
                  style={{
                    padding: '1rem',
                    marginBottom: '1.5rem',
                    borderRadius: '6px',
                    backgroundColor: submitType === 'success' ? '#d4edda' : '#f8d7da',
                    color: submitType === 'success' ? '#155724' : '#721c24',
                    border: `1px solid ${submitType === 'success' ? '#c3e6cb' : '#f5c6cb'}`,
                    fontSize: '0.95rem',
                    lineHeight: '1.5',
                  }}
                >
                  <strong>{submitType === 'success' ? '✅ ' : '❌ '}</strong>
                  {submitMessage}
                </div>
              )}

              <form className="contact-form" onSubmit={handleEmailSubmit}>
                <div className="form-group">
                  <label htmlFor="name">Nombre completo *</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    minLength="2"
                    maxLength="100"
                    placeholder="Tu nombre"
                    disabled={isSubmitting}
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="email">Correo electrónico *</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    placeholder="tucorreo@ejemplo.com"
                    disabled={isSubmitting}
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="phone">Teléfono *</label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    required
                    minLength="8"
                    maxLength="20"
                    placeholder="55 1234 5678"
                    disabled={isSubmitting}
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="message">Mensaje *</label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    required
                    minLength="10"
                    maxLength="1000"
                    rows="5"
                    placeholder="Cuéntanos cómo podemos ayudarte..."
                    disabled={isSubmitting}
                  ></textarea>
                </div>

                <button
                  type="submit"
                  className="btn btn-primary btn-block"
                  disabled={isSubmitting || !recaptchaLoaded}
                  style={{
                    opacity: isSubmitting || !recaptchaLoaded ? 0.6 : 1,
                    cursor: isSubmitting || !recaptchaLoaded ? 'not-allowed' : 'pointer',
                  }}
                >
                  {isSubmitting ? '📤 Enviando...' : '📧 Enviar Mensaje'}
                </button>
              </form>

              <p className="form-note">
                Tu mensaje será enviado directamente a nuestro equipo. Te responderemos a la brevedad.
              </p>
              <p className="form-note" style={{ fontSize: '0.75rem', marginTop: '0.5rem', opacity: 0.7 }}>
                Este sitio está protegido por reCAPTCHA y se aplican la{' '}
                <a
                  href="https://policies.google.com/privacy"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: '#3A6FB0' }}
                >
                  Política de Privacidad
                </a>{' '}
                y los{' '}
                <a
                  href="https://policies.google.com/terms"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: '#3A6FB0' }}
                >
                  Términos de Servicio
                </a>{' '}
                de Google.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Mapa Interactivo */}
      <section className="map-section">
        <div className="container">
          <h2 className="section-title">Nuestra Ubicación</h2>
          <p className="section-text center" style={{ marginBottom: '2rem' }}>
            C. Felipe Vinicio V. Berriozábal Mza 17 Lt 33, Coacalco, Estado de México
          </p>
          <div className="map-container">
            <MapaInteractivo height="400px" />
          </div>
        </div>
      </section>

      {/* CTA de WhatsApp */}
      <section className="whatsapp-cta-section">
        <div className="container">
          <div className="whatsapp-cta-box">
            <div className="whatsapp-cta-icon">💬</div>
            <div className="whatsapp-cta-content">
              <h3>¿Prefieres WhatsApp?</h3>
              <p>Chatea con nosotros directamente y recibe respuesta inmediata</p>
              <button className="btn btn-whatsapp-large" onClick={handleWhatsAppClick}>
                Abrir WhatsApp
              </button>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
